import { defineStore } from 'pinia'
import { ref } from 'vue'
import userAxios from '../includes/axios';

export const useNewsStore = defineStore("news", () => {
	// Properties
	const unreadCount = ref()
	const promotedNewsItem = ref()

	/**
	 * Load the count of unread news
	 */
	async function loadUnreadNewsCount(){
		const { data } = await userAxios.get('/api/user-side/getUserUnreadNewsQuantity');
		unreadCount.value = parseInt(data)
	}

	return {
		unreadCount,
		promotedNewsItem,
		loadUnreadNewsCount,
	}
})